// extracted by mini-css-extract-plugin
export default {"container":"nL-z","topReviewHeading":"oL-z","criticalReview":"pL-z","favorableReview":"qL-z","vsSeparator":"rL-z"};